const { REACT_APP_ENV: ENV = 'development' } = import.meta.env;

export default function env(key: string): string | undefined {
  return import.meta.env[`VITE_REACT_APP_${ENV.toUpperCase()}_${key}`];
}
